/* eslint-disable no-undef */
/**
 * Power 会话（企微客服）深链
 * ------------------------------------------------------------------
 * 原先「商家成员」卡片头部与顶部操作区各硬编码了一份同样的 URL 模板，改一处容易漏一处。
 * 注：detail/components/coachDetails 里还有一份既有实现（旧业务组件，未纳入本次重构，暂不合并）。
 *
 * @param encryptUserId   教练的 encryptUserId（必传；为空则不生成链接）
 * @param encryptTenantId 商家 encryptTenantId（可选，带上可定位到商家）
 * @returns 深链字符串；encryptUserId 为空时返回空串
 */
const powerChatUrl = ({ encryptUserId, encryptTenantId } = {}) => {
  if (!encryptUserId) return '';
  const tenant = encryptTenantId ? `&encryptTenantId=${encryptTenantId}` : '';
  /* UMI_MINI_H5HOST 由构建期注入（仓内既有写法），此处沿用 */
  return `${UMI_MINI_H5HOST}/litta-h5/#/customerService/chat?from=palmer&encryptUserId=${encryptUserId}${tenant}`;
};

export default powerChatUrl;
